import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/form/caregiver',
    component: () => import('@/views/form/CaregiverForm.vue'),
    meta: { public: true, title: '阿姨信息登记' }
  },
  {
    path: '/form/employer',
    component: () => import('@/views/form/EmployerForm.vue'),
    meta: { public: true, title: '服务需求登记' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        meta: { title: '工作台', icon: 'el-icon-odometer' }
      },
      {
        path: 'service',
        name: 'Service',
        component: () => import('@/views/service/Index.vue'),
        meta: { title: '服务管理', icon: 'el-icon-s-shop' }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/order/Index.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'member',
        name: 'Member',
        component: () => import('@/views/member/Index.vue'),
        meta: { title: '会员卡管理', icon: 'el-icon-bank-card' }
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/coupon/Index.vue'),
        meta: { title: '优惠券管理', icon: 'el-icon-present' }
      },
      {
        path: 'timeslot',
        name: 'TimeSlot',
        component: () => import('@/views/timeslot/Index.vue'),
        meta: { title: '时段配置', icon: 'el-icon-time' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/Index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'staff',
        name: 'Staff',
        component: () => import('@/views/staff/Index.vue'),
        meta: { title: '员工管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'caregiver-reg',
        name: 'CaregiverReg',
        component: () => import('@/views/caregiverReg/Index.vue'),
        meta: { title: '阿姨登记', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'employer-demand',
        name: 'EmployerDemand',
        component: () => import('@/views/employerDemand/Index.vue'),
        meta: { title: '雇主需求', icon: 'el-icon-document' }
      },
      {
        path: 'stat',
        name: 'Stat',
        component: () => import('@/views/stat/Index.vue'),
        meta: { title: '数据统计', icon: 'el-icon-data-analysis' }
      },
      {
        path: 'system',
        name: 'System',
        component: () => import('@/views/system/Index.vue'),
        meta: { title: '系统设置', icon: 'el-icon-setting' }
      },
      {
        path: 'grid-menu',
        name: 'GridMenu',
        component: () => import('@/views/system/GridMenu.vue'),
        meta: { title: '宫格菜单', icon: 'el-icon-menu' }
      },
      {
        path: 'faq',
        name: 'Faq',
        component: () => import('@/views/faq/Index.vue'),
        meta: { title: '常见问题', icon: 'el-icon-question' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
